import React from 'react';
import Money from "../../../../../../../components/Common/Money";
import {useTranslation} from "react-i18next";
import {ReactComponent as MenuItemIco} from "../../../../../../../../images/icons/menus/menu-item.svg";
import {ReactComponent as MenuItemDarkIco} from "../../../../../../../../images/icons/menus/menu-item-dark.svg";
import AppConfig from "../../../../../../../services/AppConfig";

interface Props {
    option: Record<string, any>;
}

const ProductModifierGroupSimpleOptionIncluded = ({option}: Props) => {
    const disabled = option.disabled;
    const optionState = option.state;
    const {t} = useTranslation();

    return (
        <div
            className={`product-item-option product-modifier-group-option product-item-option-included ${disabled ? "disabled" : ""}`}>
            <div className="product-image">
                {option.image_link ? (
                    <img alt={t("common.word.product_image")}
                         src={option.image_link.default}/>
                ) : (
                    AppConfig.isDarkMode() ? <MenuItemDarkIco/> : <MenuItemIco/>
                )}
            </div>
            <div className="d-flex flex-column w-100">
                {disabled &&
                    <small className="text-warning fw-normal">{t("modules.menu.product_not_available.field")}</small>}
                <h1 className="h6">
                    {option.name}
                </h1>
                {option.description && (
                    <p className="fw-normal">{option.description}</p>
                )}
                <div className="d-flex justify-content-between align-items-center gap-3 w-100">
                    <div className="prices-container d-flex flex-column">
                        <p>
                            <Money value={optionState.total_price}/>
                        </p>
                        {
                            optionState.quantity > 1 && optionState.quantity - optionState.quantity_free > 1 && (
                                <small className="d-inline-block">
                                    (<Money value={optionState.unit_total_price}/> / {t("modules.menu.field.piece.title")})
                                </small>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductModifierGroupSimpleOptionIncluded;